import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumDivingContentSectionHeaderCls: string;
			aboutAboutHeliumDivingContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Diving extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Diving Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumDivingContentSectionHeaderCls || '','about_about_helium_diving', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumDivingContentSectionTextInnerCls || '','about_about_helium_diving', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Diving;